import { Feature, type VisualElement } from "motion-dom"
import { noop } from "motion-utils"
import { VisualElementDragControls } from "./VisualElementDragControls"

export class DragGesture extends Feature<HTMLElement> {
    controls: VisualElementDragControls

    removeGroupControls: Function = noop
    removeListeners: Function = noop

    constructor(node: VisualElement<HTMLElement>) {
        super(node)
        this.controls = new VisualElementDragControls(node)
    }

    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps()

        if (dragControls) {
            this.removeGroupControls = dragControls.subscribe(this.controls)
        }

        this.removeListeners = this.controls.addListeners() || noop
    }

    update() {
        const { dragControls } = this.node.getProps()
        const { dragControls: prevDragControls } = this.node.prevProps || {}

        if (dragControls !== prevDragControls) {
            this.removeGroupControls()
            if (dragControls) {
                this.removeGroupControls = dragControls.subscribe(this.controls)
            }
        }
    }

    unmount() {
        this.removeGroupControls()
        this.removeListeners()
    }
}
